var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from 'react';
import { Form, Select } from '@robinpowered/ui-kit';
import { useTranslation } from 'react-i18next';
import { useConfig } from '../../context/ConfigContext';
import { useEventApi, } from '../../hooks/useEvent/useEventApi';
import { faVideoCamera } from '@awesome.me/kit-cf858715fd/icons/classic/solid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEventComposerGlobalContext } from '../../composers/EventComposerGlobalContext';
import { useFormContext, useWatch } from 'react-hook-form';
import { ComposerSection } from '../common/ComposerSection';
var toPascalCase = function (raw) {
    if (!raw)
        return '';
    return raw
        .split(/[_\s-]+/)
        .filter(Boolean)
        .map(function (word) { return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(); })
        .join('');
};
export var VideoIntegration = function () {
    var t = useTranslation('meetingRooms').t;
    var onError = useEventComposerGlobalContext().onError;
    var _a = useConfig(), userContext = _a.userContext, environmentUrls = _a.environmentUrls, tenantId = _a.tenantId, accessToken = _a.accessToken;
    var currentOrg = userContext.currentOrg, currentUser = userContext.currentUser;
    var integrationsServiceUrl = environmentUrls.integrationsServiceUrl, apiUrl = environmentUrls.apiUrl, baseApiUrl = environmentUrls.baseApiUrl;
    var _b = __read(useState([]), 2), availableVideoIntegrations = _b[0], setAvailableVideoIntegrations = _b[1];
    var videoIntegrationId = useWatch().videoIntegrationId;
    var setValue = useFormContext().setValue;
    // Start true so we don't flash the + button before the initial fetch settles.
    var _c = __read(useState(true), 2), gettingVideoIntegrations = _c[0], setGettingVideoIntegrations = _c[1];
    var getVideoIntegration = useEventApi({
        onError: onError,
        apiUrl: apiUrl,
        baseApiUrl: baseApiUrl,
        integrationsServiceUrl: integrationsServiceUrl,
        currentOrg: currentOrg,
        tenantId: tenantId,
        accessToken: accessToken,
    }).getVideoIntegration;
    var loadVideoIntegrations = useCallback(function () {
        var userId = currentUser === null || currentUser === void 0 ? void 0 : currentUser.id;
        if (!userId) {
            setGettingVideoIntegrations(false);
            return;
        }
        setGettingVideoIntegrations(true);
        getVideoIntegration(userId)
            .then(function (integrations) {
            if (integrations) {
                setAvailableVideoIntegrations(integrations.filter(function (integration) { return integration.available; }));
            }
        })
            .catch(function (error) {
            onError(error);
        })
            .finally(function () {
            setGettingVideoIntegrations(false);
        });
    }, [getVideoIntegration, currentUser === null || currentUser === void 0 ? void 0 : currentUser.id, onError]);
    // Prefetch so we can hide the section entirely when none are available.
    useEffect(function () {
        loadVideoIntegrations();
    }, [loadVideoIntegrations]);
    var validAvailableVideoIntegrations = availableVideoIntegrations.filter(function (integration) {
        return !!integration && typeof integration.id === 'number';
    });
    // Still loading, or nothing available — don't render the section.
    if (gettingVideoIntegrations || !validAvailableVideoIntegrations.length) {
        return null;
    }
    return (_jsx(ComposerSection, { label: t('video_integration.label'), sectionOpen: false, SectionButtonContainerStyle: { paddingBottom: 20 }, children: _jsx(Form.Item, { style: { marginBottom: 0 }, label: t('video_integration.label'), children: _jsx(Select, { style: { width: '100%' }, value: videoIntegrationId !== null && videoIntegrationId !== void 0 ? videoIntegrationId : null, onChange: function (value) {
                    setValue('videoIntegrationId', value !== null && value !== void 0 ? value : null, {
                        shouldDirty: true,
                    });
                }, allowClear: true, prefix: _jsx(FontAwesomeIcon, { icon: faVideoCamera }), options: __spreadArray([
                    {
                        value: null,
                        label: t('video_integration.none', 'No integration'),
                    }
                ], __read(validAvailableVideoIntegrations.map(function (videoIntegration) {
                    var label = toPascalCase(videoIntegration.type) ||
                        "#".concat(videoIntegration.id);
                    return {
                        value: videoIntegration.id,
                        label: label,
                    };
                })), false), placeholder: t('video_integration.none', 'No integration') }) }) }));
};
